import React from 'react'
import PropTypes from 'prop-types'
import { LOCKED_CONTENT_TEXT } from 'Defaults/listing'
import { _TermsUseText } from './styles'

const ListingPreviewLockedText = (
  {
    source,
    requireTermsConditionAgreement,
    requiredEmailVerification,
    showShortText = false,
  },
) => (
  requireTermsConditionAgreement ? (
    <_TermsUseText data-test-id="termsOfUsText">
      <div>Agree to {source}{source === 'PILLAR9' ? '\u2122' : ''} terms to view.</div>
      {!showShortText && <div>Please Click here.</div>}
    </_TermsUseText>
  ) : requiredEmailVerification ?
    LOCKED_CONTENT_TEXT.EMAIL_VERIFY :
    LOCKED_CONTENT_TEXT.LOGIN_REQUIRED
)

ListingPreviewLockedText.propTypes = {
  source: PropTypes.string,
  requireTermsConditionAgreement: PropTypes.bool,
  requiredEmailVerification: PropTypes.bool,
  showShortText: PropTypes.bool,
}

export default ListingPreviewLockedText

